module.exports = __webpack_public_path__ + "img/c99c5d2.jpg";